import React, { PureComponent } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PhotoSortContainer from '../components/PhotoSortContainer';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';

import { populateListingFromFormData } from '../helpers';
import { updateListing, setListing, updateListingPhotosOrder, updateFormData } from '../actions';
import { ListingPhotosSchema } from '../validation';

const mapStateToProps = state => ({
  listing: state.Listing
});

class ListingFormPhotosOrder extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      orderedPhotos: [],
      screenWidth: window.innerWidth
    };

    const workflow = this.props.workflow ? this.props.workflow : 'forms';
    this.nextPage = `/${this.props.parent}/listing/${workflow}/pricing`;
    this.prevPage = `/${this.props.parent}/listing/${workflow}/photos`;
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  saveListing = (values, pathAfterSave) => {
    this.setState({ isSubmitting: true });
    let { dispatch, listing, step, history } = this.props;
    this.state.orderedPhotos.length > 0 && this.props.dispatch(updateListingPhotosOrder(this.state.orderedPhotos));
    if (values.lastCompleted < step) {
      values.lastCompleted = step;
    }

    setTimeout( ( ) => {
      dispatch(
        updateFormData(values)
      );
      let updatedData = populateListingFromFormData(values);
      if (!updatedData._id) {
        updatedData._id = listing.listingData._id;
      }
      dispatch(setListing(updatedData));
      dispatch(updateListing())
      .then(() => {
        history.push(pathAfterSave);
      })
    },1000)
  }

  submitAndExit = values => {
    this.saveListing( values, `/${this.props.parent}/manage-listings` )
  }

  submitAndBack = values => {
    this.saveListing( values, this.prevPage )
  }

  onSubmit = ( values, { setSubmitting }) => {
    setSubmitting( false )
    this.saveListing(values, this.nextPage)
  }

  exit = ( values, { setSubmitting } ) => {
    let { dispatch, history } = this.props;
    this.setState( { isSubmitting: true } );
    if (this.state.orderedPhotos.length) {
      values.photos = this.state.orderedPhotos;
    }
    let updatedData = populateListingFromFormData(values);
    setTimeout(() => {
      setSubmitting(false);
      dispatch(setListing(updatedData));
      dispatch(updateListing(true)).then(() => {
        history.push(`/${this.props.parent}/manage-listings`);
      });

    }, 500)
  }

  setNewCardsList = (newCardsList) => {
    this.setState({ orderedPhotos: newCardsList });
  }

  render() {
    let values = this.props.listing.formData;
    let allImagesLoaded = this.props.listing.photos.every(x => (x instanceof Blob));
    let isMobile = this.state.screenWidth <= 576;
    const submitButtonText = this.props.exit ? 'Save' : 'Next';
    return (
      <Formik onSubmit={this.props.exit ? this.exit : this.onSubmit} initialValues={values} validationSchema={ListingPhotosSchema}>
        {({ values, errors, setFieldValue, submitForm }) => (
          <Form>
            <div>
              <h5>Manage Photos</h5>
              <div className="pb-3">
                Click and drag photos (up/down) to change the order that you would like your photos to be displayed.
              </div>
              <div><strong>2) Display Order</strong></div>
              <Field name="photos">
                {() => (
                  allImagesLoaded && <DndProvider backend={isMobile ? TouchBackend : HTML5Backend} className="sort-list">
                    <PhotoSortContainer images={this.props.listing.photos} newCardsList={this.setNewCardsList} />
                  </DndProvider>
                )}
              </Field>
              <ErrorMessage name="photos" component="div" className="error-message"/>
            </div>
            <div className="button-row row">
              <div className="col-4">
                <label className="float-left"
                  onClick={() => { this.submitAndBack(values) }}>
                  Back
                </label>
              </div>
              <div className="col-8">
                <div className="row">
                  <div className="col-md-6 col-12">
                    {
                    this.props.workflow !== "edit" &&
                      <label className="float-right" onClick={() => { this.submitAndExit(values) }}>
                        Save &amp; Finish Later
                      </label>
                    }
                  </div>
                  <div className="col-md-6 col-12">
                    {this.state.isSubmitting ?
                      <button
                        className="btn-primary float-right"
                        disabled={true} onClick={() => { }}>Saving...</button> :
                      <button className="btn-primary float-right" type="submit">
                        {submitButtonText}
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }
}

export default withRouter(connect(mapStateToProps)(ListingFormPhotosOrder));
